import { render } from "./competition_user_completed.vue?vue&type=template&id=4dca5ac4&scoped=true"
import script from "./competition_user_completed.vue?vue&type=script&lang=js"
export * from "./competition_user_completed.vue?vue&type=script&lang=js"

import "./competition_user_completed.vue?vue&type=style&index=0&id=4dca5ac4&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dca5ac4"]])

export default __exports__